// 逆运动学与角度计算相关的纯函数工具

// 逆运动学计算：根据末端位置计算舵机角度
export function calculateInverseKinematics(x, y, armLengths, servoDistance) {
  const { L1, L2, L3, L4 } = armLengths

  // 舵机A（左）的固定点
  const servoA_X = -servoDistance / 2
  const servoA_Y = 0

  // 舵机B（右）的固定点
  const servoB_X = servoDistance / 2
  const servoB_Y = 0

  // 计算到两个舵机的距离
  const distA = Math.sqrt((x - servoA_X) ** 2 + (y - servoA_Y) ** 2)
  const distB = Math.sqrt((x - servoB_X) ** 2 + (y - servoB_Y) ** 2)

  // 检查是否在可达范围内
  const maxDistA = L1 + L2
  const minDistA = Math.abs(L1 - L2)
  const maxDistB = L3 + L4
  const minDistB = Math.abs(L3 - L4)

  if (distA < minDistA || distA > maxDistA || distB < minDistB || distB > maxDistB) {
    return null // 不可达
  }

  // 计算舵机A的角度（左边舵机，取左边的解）
  const angleA1 = Math.atan2(y - servoA_Y, x - servoA_X)
  const cosAngleA2 = (L1 ** 2 + distA ** 2 - L2 ** 2) / (2 * L1 * distA)
  const sinAngleA2 = Math.sqrt(1 - cosAngleA2 ** 2)
  // 左边舵机取左边的解（elbow out），使用负的sinAngleA2
  const angleA = angleA1 - Math.atan2(-sinAngleA2, cosAngleA2)

  // 计算舵机B的角度（右边舵机，取右边的解）
  const angleB1 = Math.atan2(y - servoB_Y, x - servoB_X)
  const cosAngleB2 = (L3 ** 2 + distB ** 2 - L4 ** 2) / (2 * L3 * distB)
  const sinAngleB2 = Math.sqrt(1 - cosAngleB2 ** 2)
  // 右边舵机取右边的解（elbow out），使用正的sinAngleB2
  const angleB = angleB1 - Math.atan2(sinAngleB2, cosAngleB2)

  return {
    servoA: angleA * 180 / Math.PI,
    servoB: angleB * 180 / Math.PI
  }
}

// 计算相对于零位的角度
export function calculateRelativeAngle(absoluteAngle, zeroAngle) {
  return Number((absoluteAngle - zeroAngle).toFixed(1))
}
